/**
 * Core Services
 */

import * as bf from './browser-features';
import * as pf from './polyfill-flags';
import * as tl from './template-loader';

export const polyfillFlags = pf;
export const templateLoader = tl;
export const browserFeatures = bf;



// WEBPACK FOOTER //
// ./project/client/src/core/services/index.js